<div class="modal-header card-header">
    <div class="col-12">
        <div class="row">
            <div class="col-6">
                <span class="text-blue text-125">Datos de Pago</span>
            </div>
            <div class="col-6">
                <button  id="venta_guardar" type="button" class="btn btn-primary" (click)="guardar()">
                    <i class="fa fa-save align-top bigger-125"></i>
                </button>&nbsp;
                <button id="cerrarV" type="button" class="btn btn-primary btn-danger" (click)="cerrarComponente()" >
                    <i class="fa fa-times red2 align-top bigger-125"></i>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-body card-body">
    <div class="widget-body">
        <div class="row">
            <div class="col-12">
                <div class="widget-box">
                    <div class="widget-body">
                        <div class="widget-main">
                            <div class="row">
                                <div class="col-6 col-md-2 col-sm-2 col-xs-2">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <label for="fefin">Fecha </label>&nbsp;
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <div class="input-group">
                                            <input [disabled]="inhabilitar_fecha" required id="fefin" name="birthday" class="form-control" placeholder="dd/mm/yyyy"
                                                    name="dp" [(ngModel)]="venta.fechaTexto" ngbDatepicker #d="ngbDatepicker">
                                            <div class="input-group-append">
                                                <button [disabled]="inhabilitar_fecha" class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                                <div *ngIf="venta.usuario.empresa.usar_sucursales" class="col-6 col-md-1 col-sm-2 col-xs-12 pl-0">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <label>Sucursal</label>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <select [compareWith]="compararObjectos" id="venta_sucursal" name="sucursal" [disabled]="inhabilitar_sucursal" class="form-control" [(ngModel)]="venta.sucursal" (change)="establecerSucursal(venta.sucursal)">
                                            <option [ngValue]="sucursal" *ngFor="let sucursal of venta.sucursales">{{sucursal.nombre}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-2 col-xs-2 pl-0">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0" >
                                        <label>Estudiante</label>&nbsp;
                                        <a class="card-toolbar-btn text-danger-m1" [disabled]="inhabilitar_cliente" href="javascript:void(0)" *ngIf="venta.cliente.id" (click)="reiniciarCliente()">
                                            <i class="fa fa-trash bigger-130 red2"></i>
                                        </a>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <input required id="venta_razon_social" name="venta_razon_social" [disabled]="inhabilitar_cliente || venta.cliente.id" 
                                            [inputFormatter]="formatter" [resultTemplate]="rt" (selectItem)="establecerCliente($event)"
                                            type="text" class="form-control" [(ngModel)]="venta.estudiante" 
                                            [ngbTypeahead]="buscarCliente" placeholder="Buscar estudiante" 
                                            (keypress)="enfocarElemento($event,'venta_id_producto')" autocomplete="off"
                                            />

                                        <ng-template #rt let-r="result" let-t="term">
                                            <img [src]="rest_server+r.imagen" class="mr-1" style="width: 16px">
                                            <ngb-highlight [result]="r.codigo+' - '+r.apellido_paterno+' '+r.apellido_materno+' '+r.nombres" [term]="t"></ngb-highlight>
                                          </ng-template>
                                    </div>
                                </div>
                                <div class="col-6 col-md-2 col-sm-2 col-xs-2 pl-0">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0" >
                                        <label>Razon Social</label>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <input class="form-control" autocomplete="off" name="razon_social" type="text" [(ngModel)]="estudiante.persona.cliente.razon_social" placeholder="Razon Social">
                                    </div>
                                </div>
                                <div class="col-6 col-sm-2 col-xs-2 pl-0">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0" >
                                        <label>Observación</label>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <input class="form-control" autocomplete="off" id="venta_observacion" name="observacion" type="text" [(ngModel)]="venta.observacion" placeholder="Observacion">
                                    </div>
                                </div>
                                <div class="col-6 col-md-1 col-sm-12 col-xs-12 pl-0">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <label>Tipo Pago</label>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <select [compareWith]="compararObjectos" id="venta_pago" name="pago" [disabled]="inhabilitar_tipo_pago" class="form-control" [(ngModel)]="venta.tipoPago" (change)="cambiarTipoPago()">
                                            <option [ngValue]="tipoPago" *ngFor="let tipoPago of tiposPago">{{tipoPago.nombre}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6 col-md-1 col-sm-2 col-xs-2 pl-0" *ngIf="venta.tipoPago.nombre_corto==gloval_variable.Dictionary.TIPO_PAGO_CONT">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <label >Pagado (Bs):</label>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <input class="form-control" id="venta_pagado" name="pagado" required type="number" step="0.01" min="{{pagoMinimo}}" [(ngModel)]="venta.pagado" (keyup)="calcularCambio()"/>
                                    </div>
                                </div>
                                <div class="pl-0 col-6 col-md-1 col-sm-2 col-xs-2" *ngIf="venta.tipoPago.nombre_corto==gloval_variable.Dictionary.TIPO_PAGO_CONT">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0" >
                                        <label>Cambio (Bs):</label>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                                        <input class="form-control" disabled type="number" step="0.01" [(ngModel)]="venta.cambio"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
<!--
            <div class="col-12 col-md-6 col-sm-6 col-lg-6 p-1">
                <div class="card bcard overflow-hidden shadow text-center">
                    <div class="card-body p-3px bgc-green-d2">
                    <div class="row">
                        <div class="col-8">
                            <span class="text-white text-125">Cobros Pendientes</span>
                        </div>
                        <div class="col-3">
                        </div>
                    </div>
                    </div>
                </div>
                <div class="card bcard overflow-hidden shadow">
                <div class="card-body p-3px bgc-green-d2">
                    <div class="radius-1 table-responsive">
                    <table class="table table-striped table-bordered table-hover brc-black-tp10 mb-0 text-grey">
                        <thead class="brc-transparent">
                        <tr class="bgc-green-d2 text-white">
                            <th style="padding-left: 0; padding-right: 0;">
                            Cuota
                            </th>
                            <th>
                            Importe
                            </th>
                            <th>
                            Desc.
                            </th>
                            <th style="text-align: center; width:250px; ">
                            Pagado
                            </th>
                            <th>
                            Obs.
                            </th>
                            <th *ngIf="usuario.empresa.usar_fechas_vencimientos_pagos_estudiantes">
                            Fecha Venc.
                            </th>
                            <th data-field="tools">
                                <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                                <div class="fht-cell"></div>
                            </th>
                        </tr>
                        </thead>
            
                        <tbody>
                        <tr class="bgc-h-yellow-l3" *ngFor="let concepto_pago_estudiante of concepto_pago.conceptos_pagos_estudiante;let i=index;">
                            <ng-container *ngIf="concepto_pago_estudiante.activo">
                            <td class="text-600 text-dark text-center">
                                {{concepto_pago_estudiante.cuota}}
                            </td>
                            <td class="text-green-m1 text-180 text-600">
                                <span class="text-dark-tp4 text-md">Bs</span>{{concepto_pago_estudiante.importe}}
                            </td>
                            <td class="text-light-m1 text-180 text-600">
                                <span class="text-dark-tp4 text-md">Bs</span>{{concepto_pago_estudiante.descuento}}
                            </td>
                            <td [ngClass]="{'text-info-m1': concepto_pago_estudiante.saldo==0, 'text-danger-m1': concepto_pago_estudiante.saldo>0}" class="text-130 text-600">
                                <ng-container *ngIf="concepto_pago_estudiante.detalles_venta">
                                <ng-container *ngIf="concepto_pago_estudiante.detalles_venta.length>0">
                                    <div class="row" *ngFor="let detalle_venta of concepto_pago_estudiante.detalles_venta">
                                    <div class="col-12">
                                        <span class="text-dark-tp4 text-md">Bs</span>{{detalle_venta.detalle_venta.total}} <span class="text-blue-m1 text-md">{{detalle_venta.detalle_venta.venta.fecha | date:"dd/MM/yyyy"}}</span> 
                                        <span class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="imprimirVenta(detalle_venta.detalle_venta.venta)">
                                        <i class="fa fa-print bigger-260 red2"></i>
                                        </span>
                                    </div>
                                    </div>
                                </ng-container>
                                <span *ngIf="concepto_pago_estudiante.detalles_venta.length>0 && (concepto_pago_estudiante.importe-sumarPagos(concepto_pago_estudiante.detalles_venta)-sumarDescuentos(concepto_pago_estudiante.detalles_venta)-concepto_pago_estudiante.saldo)>0" ><span class="text-dark-tp4 text-md">Bs</span>{{(concepto_pago_estudiante.importe-sumarPagos(concepto_pago_estudiante.detalles_venta)-sumarDescuentos(concepto_pago_estudiante.detalles_venta)-concepto_pago_estudiante.saldo).toFixed(2)}}</span>
                                <span *ngIf="concepto_pago_estudiante.detalles_venta.length==0 && (concepto_pago_estudiante.importe==concepto_pago_estudiante.pagado || concepto_pago_estudiante.pagado>0)" ><span class="text-dark-tp4 text-md">Bs</span>{{concepto_pago_estudiante.pagado}}</span>
                                <span *ngIf="concepto_pago_estudiante.detalles_venta.length==0 && concepto_pago_estudiante.importe>concepto_pago_estudiante.pagado && concepto_pago_estudiante.pagado==0" ><span class="text-dark-tp4 text-md">Bs</span>0</span>
                                </ng-container>
                            </td>
                            <td>
                                {{concepto_pago_estudiante.observacion}}
                            </td>
                            <td class="text-danger-m1 text-130" *ngIf="usuario.empresa.usar_fechas_vencimientos_pagos_estudiantes">
                                <div class="row" *ngIf="!concepto_pago_estudiante.fv_modificar">
                                <div class="col-md-12 col-sm-12 col-12">
                                    {{concepto_pago_estudiante.fecha_vencimiento | date:"dd/MM/yyyy"}}
                                </div>
                                <div class="col-md-12 col-sm-12 col-12">
                                    <a *ngIf="aplicacion_estudiantes.puede_modificar" class="btn-sm btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="modificarFechaVencimiento(concepto_pago_estudiante)">
                                        <i class="ace-icon fa fa-edit bigger-60"></i>
                                    </a>
                                </div>
                                </div>
                                <div class="row" *ngIf="concepto_pago_estudiante.fv_modificar">
                                <div class="col-md-12 col-sm-12 col-12">
                                    <div class="input-group">
                                    <input name="{{concepto_pago_estudiante.id?concepto_pago_estudiante.id:i}}" class="form-control" placeholder="dd/mm/yyyy"
                                            [(ngModel)]="concepto_pago_estudiante.fecha_vencimiento_texto" ngbDatepicker #d="ngbDatepicker">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                                    </div>
                                    </div> 
                                </div>
                                <div class="col-md-12 col-sm-12 col-12">
                                    <a class="btn-sm btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="establecerFechaVencimiento(concepto_pago_estudiante)">
                                        <i class="ace-icon fa fa-check-square bigger-60"></i>
                                    </a>
                                </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <a *ngIf="aplicacion_estudiantes.puede_modificar && concepto_pago_estudiante.pagado==0" title="Modificar Importe" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="abrirCambioImporteModal(concepto_pago_estudiante)">          
                                    <i class="fa fa-pencil-alt text-105"></i>        
                                </a>
                                <a *ngIf="aplicacion_estudiantes.puede_eliminar && concepto_pago_estudiante.pagado==0" title="Eliminar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacion(concepto_pago_estudiante)">          
                                    <i class="fa fa-trash-alt text-105"></i>        
                                </a> 
                            </td>
                            </ng-container>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
        
            </div> -->

            <div class="col-12 col-md-5">
                <div class="widget-box">
                    <div class="card bgc-dark">
                        <div class="card-header card-header-sm">
                            <h5 class="card-title text-110 text-white font-light pt-1">Cobros Pendientes</h5>
                        </div>
                        <div class="card bcard overflow-hidden shadow">
                            <div class="card-body p-3px">
                                <div class="radius-1 table-responsive">
                                    <table class="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th style="padding-right: 0; padding-left: 0;">
                                                    <label>Nº</label>
                                                </th>
                                                <th>
                                                    <label>Concepto de Pago</label>
                                                </th>
                                                <th style="padding-right: 0; padding-left: 0;">
                                                    <label>Importe (Bs)</label>
                                                </th>
                                                <th style="padding-right: 0; padding-left: 0;">
                                                    <label>Desc. (Bs)</label>
                                                </th>
                                                <th>
                                                    <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                                                    <div class="fht-cell"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let servicio_pendiente of servicios_pendientes; let i=index; ">
                                                <tr  *ngIf="!servicio_pendiente.eliminado">
                                                    <td>
                                                        {{i+1}}
                                                    </td>
                                                    <td *ngIf="usuario.empresa.usar_ingresos_economicos_instituto">
                                                        {{servicio_pendiente.concepto_pago.concepto.nombre}}<br>
                                                        {{servicio_pendiente.concepto_pago.carrera.nombre}}<br>
                                                        {{servicio_pendiente.concepto_pago.gestion?servicio_pendiente.concepto_pago.gestion.nombre:''}}<br>
                                                        {{servicio_pendiente.concepto_pago.semestre?servicio_pendiente.concepto_pago.semestre.nombre:''}}<br>
                                                    </td>
                                                    <td *ngIf="usuario.empresa.usar_ingresos_economicos_colegio">
                                                        {{servicio_pendiente.descripcion}}
                                                    </td>
                                                    <td>
                                                        {{servicio_pendiente.importe}}
                                                    </td>
                                                    <td>
                                                        {{servicio_pendiente.descuento}}
                                                    </td>
                                                    <td>
                                                        <button (click)="agregarServicioPendiente(servicio_pendiente)" class="btn btn-primary btn-sm"><i class="fa fa-plus bigger-130"></i></button>&nbsp;<br>
                                                        <button (click)="abrirPopupConfirmacionEliminacion(servicio_pendiente)" class="btn btn-danger btn-sm"><i class="fa fa-trash bigger-130"></i></button>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <tr>
                                                <td>
                                                    
                                                </td>
                                                <td>
                                                    <b>TOTALES</b>
                                                </td>
                                                <td>
                                                    {{sumarServiciosPendientes()}}
                                                </td>
                                                <td >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-7">
                <div class="widget-box">
                    <div class="card bgc-dark" *ngIf="venta.detallesVenta.length>0">
                        <div class="card-header card-header-sm">
                            <h5 class="card-title text-110 text-white font-light pt-1">DETALLE DE PAGO</h5>
                        </div>
                        <div class="card bcard overflow-hidden shadow" *ngIf="venta.detallesVenta.length>0">
                            <div class="card-body p-3px">
                                <div class="radius-1 table-responsive">
                                    <table class="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th style="padding-right: 0; padding-left: 0;">
                                                    <label>Nº</label>
                                                </th>
                                                <th>
                                                    <label>Concepto de Pago</label>
                                                </th>
                                                <th>
                                                    <label>Cuota</label>
                                                </th>
                                                <th>
                                                    <label>Importe (Bs)</label>
                                                </th>
                                                <th>
                                                    <label>Desc. (Bs)</label>
                                                </th>
                                                <th>
                                                    <label>Total (Bs)</label>
                                                </th>
                                                <th>
                                                    <label>Pagado (Bs)</label>
                                                </th>
                                                <th>
                                                    <label>Saldo (Bs)</label>
                                                </th>
                                                <th>
                                                    <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                                                    <div class="fht-cell"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let detalleVenta of venta.detallesVenta | orderBy:['id_estudiante_concepto_pago','cuota']; let i=index;">
                                                <tr  *ngIf="!detalleVenta.eliminado">
                                                    <td>
                                                        {{i+1}}
                                                    </td>
                                                    <td *ngIf="usuario.empresa.usar_ingresos_economicos_instituto">
                                                        {{detalleVenta.concepto_pago.concepto.nombre}}<br>
                                                        {{detalleVenta.concepto_pago.carrera.nombre}}<br>
                                                        {{detalleVenta.concepto_pago.gestion?detalleVenta.concepto_pago.gestion.nombre:''}}<br>
                                                        {{detalleVenta.concepto_pago.semestre?detalleVenta.concepto_pago.semestre.nombre:''}}<br>
                                                    </td>
                                                    <td *ngIf="usuario.empresa.usar_ingresos_economicos_colegio">
                                                        {{detalleVenta.concepto_pago.concepto.nombre}}<br>
                                                        {{detalleVenta.concepto_pago.gestion?detalleVenta.concepto_pago.gestion.nombre:''}}<br>
                                                    </td>
                                                    <td>
                                                        {{detalleVenta.cuota}}
                                                    </td>
                                                    <td>
                                                        {{detalleVenta.importe}}
                                                    </td>
                                                    <td class="input-cal">
                                                        <input class="form-control" name="descuento_{{detalleVenta.concepto_pago.id}}" required type="number" step="0.01" min="0" [(ngModel)]="detalleVenta.descuento" (keyup)="calcularDescuentoDetalleVenta(detalleVenta)"/>
                                                    </td>
                                                    <td>
                                                        {{detalleVenta.total}}
                                                    </td>
                                                    <td class="input-cal">
                                                        <input class="form-control" name="pagado_{{detalleVenta.concepto_pago.id}}" required type="number" step="0.01" min="0.10" [(ngModel)]="detalleVenta.pagado" (keyup)="establecerPagadoDetalleVenta(detalleVenta)"/>
                                                    </td>
                                                    <td>
                                                        {{detalleVenta.saldo}}
                                                    </td>
                                                    <td>
                                                        <button (click)="eliminarDetalleVenta(detalleVenta)" class="btn btn-danger btn-sm"><i class="fa fa-trash bigger-130"></i></button>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <tr>
                                                <td>
                                                    
                                                </td>
                                                <td>
                                                    <b>TOTALES</b>
                                                </td>
                                                <td>
                                                    
                                                </td>
                                                <td>
                                                    {{venta.importe}}
                                                </td>
                                                <td>
                                                    {{venta.descuento}}
                                                </td>
                                                <td>
                                                    {{venta.total}}
                                                </td>
                                                <td>
                                                    <i class="eva eva-paper-plane-outline text-160 radius-round bgc-success-l4 text-success p-2 border-2 brc-success-m3">{{calcularPagado()}}</i>
                                                </td>
                                                <td >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>